import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Container, Dimmer, Form, Icon, Loader, Table } from 'semantic-ui-react';
import { formatDate, parseDeliveryStatus } from '../../../utils/shared.utils';
import { orderAddressText } from '../../../utils/orderDelivery';
import './order.report.scss';
import './delivery.report.scss';

function ReportDeliveries(props: any) {

  const history = useHistory()
  const [deliveries, setDeliveries] = useState<any[]>([])
  //test
  // const [page, setPage] = useState({ page: 1, size: 10, totalPages: 1 })
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [fetched, setFetched] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)

  const today = new Date();
  const weekAfter = new Date();
  weekAfter.setDate(weekAfter.getDate() + 7);

  const [startDate, setStartDate] = useState(formatDate(today))
  const [endDate, setEndDate] = useState(formatDate(weekAfter))

  useEffect(() => {
    setTimeout(() => {
      if (fetched) {
        return
      }
      fetchReport();
      setFetched(true) 
    });
  }, []);

  const fetchReport = (storeOverride?: number) => {
    
    var token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      if (!startDate) {
        setErrorMsg("Эхний өдөр оруулна уу")
        return;
      }
      if (!endDate) {
        setErrorMsg("Сүүлийн өдөр оруулна уу")
        return;
      }

      // fetch report data
      setLoading(true)
      const storeParam = storeOverride !== undefined ? storeOverride : activeTabIndex
      fetch(process.env.REACT_APP_API_URL + 'mongol/deliveries', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ startDate: startDate, endDate: endDate, store: storeParam })
      }).then((res: any) => {
        setLoading(false)
        if (res.ok) {
          res.json().then((resJson: any) => {
            let data: any[] = resJson.data;
            for (let delivery of data) {
              let date = new Date(delivery.date)
              delivery.date = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`
              delivery.showItems = true;
              delivery.orders.forEach((o: any) => o.showItems = true);
            }
            setDeliveries(data)
            // setPage(resJson.page)
          })
        }
      }).catch(err => {
        setLoading(false)
        setErrorMsg("Сүлжээний алдаа")
        console.error(err)
      })
    }
    else {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
    }
  }

  // const onPageChange = (event: any, data: any) => {
  //     setPage(Object.assign(page, { page: data.activePage }))
  //     fetchOrders(data.activePage)
  //     window.scrollTo(0, 100)
  // }

  return (
    <div className="page-admin margin-top-50-sm">
      <Container>
        <div className="flex-div width-100">
          <Dimmer active={loading} inverted>
            <Loader size='medium'></Loader>
          </Dimmer>
          <section className="admin-reports delivery-report-section" id="my-form">

            <div className="width-100 text-center"><h2>Хүргэлтийн тайлан</h2></div>

            <div className="tab-head">
              <div
                className={"tab-header" + (activeTabIndex === 0 ? " selected" : "")}
                onClick={() => { setActiveTabIndex(0); fetchReport(0); }}
              >
                Веб
              </div>
              <div
                className={"tab-header" + (activeTabIndex === 1 ? " selected" : "")}
                onClick={() => { setActiveTabIndex(1); fetchReport(1); }}
              >
                Дэлгүүр
              </div>
            </div>

            <Form className="report-filter flex-div margin-top-50">
              <Form.Input label="Хүргэлтийн эхний өдөр: " type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}/>
              <Form.Input label="Хүргэлтийн сүүлийн өдөр: " type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}/>
              <Form.Field className="report-filter-actions">
                <label>&nbsp;</label>
                <Button type="button" onClick={() => fetchReport()}>Хайх</Button>
              </Form.Field>
            </Form>

            <div className="error-msg width-100 text-center">{ errorMsg }</div>
            
            {deliveries?.map((del: any, delIndex: number) => {
              return <React.Fragment key={"delivery-" + delIndex + "-" + del.date}>
                <h3 className="admin-reports-date-heading"><strong>{del.date}</strong></h3>
                <Table striped singleLine className="admin-list-table delivery-report-table">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell className="delivery-report-col-id">№</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-token">Токен</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-print">Хэвлэлт</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-status">Төлөв</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-client">Хэрэглэгч</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-company">Байгууллага</Table.HeaderCell>
                      <Table.HeaderCell className="delivery-report-col-address">Хаяг</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                  {del.orders?.map((order: any, orderIndex: number) => {
                    return <React.Fragment key={"order-" + order.id + "-" + orderIndex}>
                    <Table.Row className="order-list-row">
                      <Table.Cell className="delivery-report-col-id" data-label="№">
                        <Link className="underline" to={"/mongol/report/order/" + order.id}>
                          <strong>#{order.id}</strong>
                        </Link>
                      </Table.Cell>
                      <Table.Cell className="delivery-report-col-token" data-label="Токен">
                        <strong>{order.token}</strong>
                        {order.express ? <span data-testid={`order-express-tag-${order.id}`}> (Express)</span> : null}
                        {order.pickup ? <span data-testid={`order-pickup-tag-${order.id}`}> (Очиж авах)</span> : null}
                      </Table.Cell>
                      <Table.Cell className="print-count-cell delivery-report-col-print" data-label="Хэвлэлт">
                        <a className="print-count-link" target="_blank" rel="noopener noreferrer" href={"/mongol/report/order/" + order.id}>
                          <Icon className="print-count-icon" name="print" />
                          <strong>{Number(order?.receiptCount) || 0}</strong>
                        </a>
                      </Table.Cell>
                      <Table.Cell className={"delivery-report-col-status order-status " + String(order.status || '').toLowerCase()} data-label="Төлөв">
                        {parseDeliveryStatus(order.status)}
                      </Table.Cell>
                      <Table.Cell className="delivery-report-col-client" data-label="Хэрэглэгч">
                        <Link className="underline" to={"/mongol/client/" + order.clientId}>{ order.ownName }</Link>
                      </Table.Cell>
                      <Table.Cell className="delivery-report-col-company" data-label="Байгууллага">
                        <Link className="underline" to={"/mongol/company/" + order.companyId}>{ order.companyName }</Link>
                      </Table.Cell>
                      <Table.Cell className="delivery-report-col-address" data-label="Хаяг">
                        <span>{orderAddressText(order)}</span>
                        {order.deliveryNote ? (
                          <div data-testid={`order-delivery-note-${order.id}`}><strong>Тайлбар:</strong> {order.deliveryNote}</div>
                        ) : null}
                      </Table.Cell>
                    </Table.Row>
                    { order.showItems && order.items?.length ? (
                      <Table.Row>
                        <Table.Cell colSpan={7} className="delivery-report-items-cell">
                          <table className="delivery-report-items-inner">
                            <thead>
                              <tr>
                                <th>Бүтээгдэхүүн</th>
                                <th>Тоо</th>
                              </tr>
                            </thead>
                            <tbody>
                              {order.items.map((item: any) => (
                                <tr key={"order-item-" + item.id}>
                                  <td>{ item.productName }</td>
                                  <td>{ item.count }</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Table.Cell>
                      </Table.Row>
                    ) : null}
                    </React.Fragment>
                  })}
                  </Table.Body>
                </Table>
                </React.Fragment>
                })
              }

            {/* <div className="flex-div margin-top-50">
              <Pagination defaultActivePage={1} value={page.page} totalPages={page.totalPages} onPageChange={onPageChange}></Pagination>
            </div> */}
          </section>
        </div>
      </Container>
    </div>
  );
}

export default ReportDeliveries;